const $slider = $('.section-slider-slider');
$slider.slick({
    infinite: false,
    dots: true,
    // adaptiveHeight: true,
    prevArrow: document.querySelector('.section-slider-controls__item--prev'),
    nextArrow: document.querySelector('.section-slider-controls__item--next')
});